<template>
  <div class="c-o-table">
    <table class="c-o-table__table">
      <thead class="c-o-table__thead">
        <tr v-if="isDesktop" class="c-o-table__tr">
          <th class="c-o-table__th">Typ</th>
          <th class="c-o-table__th">Företag</th>
          <th class="c-o-table__th">Kontaktperson</th>
          <th class="c-o-table__th">Telefon</th>
          <th class="c-o-table__th">Mail</th>
          <th class="c-o-table__th">Omdöme</th>
          <th class="c-o-table__th">Svarstid</th>
          <th class="c-o-table__th">Mailsvar</th>
        </tr>
        <tr v-else class="c-o-table__tr">
          <th class="c-o-table__th" :colspan="colspanAll">Företag</th>
        </tr>
      </thead>
      <tbody class="c-o-table__tbody">

        <interested-companies-row
          :colspanAll="colspanAll"
          v-for="company in this.companies"
          :key="company.Id"
          :company="company"
        ></interested-companies-row>
      </tbody>
    </table>
  </div>
</template>

<script>
import InterestedCompaniesRow from "../molecules/MoleculeInterestedCompaniesTableRow.vue";

export default {
  props: ["companies"],
  data() {
    return {
      colspanAll: 8,
    };
  },
  components: {
    InterestedCompaniesRow
  },
  computed: {
    hasMailAnswer: function() {
      return this.companies.some(company => company.Emails.length > 0)
        ? true
        : false;
    },
    isDesktop: function() {
      return this.$mq === "xLarge" ? true : false;
    },
  },

};
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/OrganismInterestedCompaniesTable.vue